import React from 'react'

const TABS = [
  { id: 'student-detail', label: 'Student Detail', icon: 'person' },
  { id: 'course', label: 'Course', icon: 'school' },
  { id: 'fees', label: 'Fees', icon: 'payments' },
  { id: 'receipt', label: 'Receipt', icon: 'receipt_long' },
]

export function StudentTabs({ activeTab, onTabChange, studentId, mode }) {
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-outline-variant/20 pb-4 mb-6">
      {TABS.map((tab) => {
        const isActive = activeTab === tab.id
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onTabChange(tab.id)}
            className={`inline-flex items-center gap-2 rounded-xl px-5 py-2.5 text-sm font-bold transition-all ${
              isActive
                ? 'bg-primary text-on-primary shadow-md shadow-primary/20 ring-2 ring-primary/30'
                : 'bg-surface-container-low text-on-surface-variant hover:bg-surface-container hover:text-on-surface'
            }`}
          >
            <span className="material-symbols-outlined text-[18px]">{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        )
      })}
    </div>
  )
}
